import { createFileRoute } from "@tanstack/react-router";
import { LabPage, labHead } from "@/components/lab-page";

export const Route = createFileRoute("/lab/estereograma")({
  head: () => labHead(
    "/lab/estereograma",
    "Gerador de estereogramas",
    "Gerador de estereogramas: imagens de profundidade escondida geradas no navegador, no projeto O que é a loucura? de Luiza Jesus do Prado.",
  ),
  component: StereogramLab,
});

function StereogramLab() {
  return <LabPage src="https://luizajprado.github.io/sirene/#estereo" title={{ pt: "Gerador de estereogramas", en: "Stereogram generator", es: "Generador de estereogramas" }} />;
}
